import React, {Component, Fragment} from "react";
import version from '../package.json';

const Footer = (props) => {

        const phone = props.election.configuration.contact?props.election.configuration.contact.phone:"+56 (2) 2712 5000";
        const email = props.election.configuration.contact?props.election.configuration.contact.email:"soporte@evoting.cl";
        return (
            <Fragment>
                <div className="row EvColor text-white p-1 justify-content-center">
                    <div className="col-12 mb-2  text-center">
                        Consultas y soporte técnico: {phone} {email}
                        <br/>
                        <small>Votación realizada con tecnología de E-Voting</small>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 text-right">
                        <small>© E-Voting 2020, v. {version.version}</small>
                    </div>
                </div>
            </Fragment>
        );
    }


export default Footer;
